/**
 * 取得素材 URL 的輔助函式，適用於 Vue CLI（webpack）環境
 * 注意：在 Vue CLI 中，動態 require 需要先預定義所有可能的素材
 * 或者把素材放在 public 目錄並使用絕對路徑
 * @param {string} name - 素材檔名，對應 assets/new_design 目錄
 * @returns {string} 素材的完整 URL
 */
export const getAssetUrl = (name) => {
  if (!name) return '';
  
  // 在 Vue CLI 中，動態路徑需要用 require.context 或先行定義
  // 這裡用映射表處理常見素材
  const assetMap = {
    '4_606.svg': require('@/assets/new_design/4_606.svg'),
    '4_611.svg': require('@/assets/new_design/4_611.svg'),
    '4_2882.svg': require('@/assets/new_design/4_2882.svg'),
    '4_470.svg': require('@/assets/new_design/4_470.svg'),
    '163_1920.svg': require('@/assets/new_design/163_1920.svg'),
    '163_1924.svg': require('@/assets/new_design/163_1924.svg'),
    '163_1932.svg': require('@/assets/new_design/163_1932.svg'),
    'standard_user.svg': require('@/assets/new_design/standard_user.svg'),
    'standard_eye.svg': require('@/assets/new_design/standard_eye.svg'),
    'standard_message.svg': require('@/assets/new_design/standard_message.svg'),
    'logo.png': require('@/assets/logo.png'),
    // 首頁素材
    'landing/landing_checkbox.svg': require('@/assets/new_design/landing/landing_checkbox.svg'),
    'landing/Landing_Sunrise.svg': require('@/assets/new_design/landing/Landing_Sunrise.svg'),
    'landing/Landing_riseup.svg': require('@/assets/new_design/landing/Landing_riseup.svg'),
    'landing/Landing_connect.svg': require('@/assets/new_design/landing/Landing_connect.svg'),
    'landing/landing_guest_1.svg': require('@/assets/new_design/landing/landing_guest_1.svg'),
    'landing/landing_guest_2.svg': require('@/assets/new_design/landing/landing_guest_2.svg'),
    'landing/landing_guest_3.svg': require('@/assets/new_design/landing/landing_guest_3.svg'),
    'landing/landing_guest_4.svg': require('@/assets/new_design/landing/landing_guest_4.svg'),
    'landing/Header_login.svg': require('@/assets/new_design/landing/Header_login.svg'),
    // 頁首素材
    'header/header_user.svg': require('@/assets/header/header_user.svg'),
    'header/header_message.svg': require('@/assets/header/header_message.svg'),
    // 辯論大廳素材
    'debate_grand/loader.gif': require('@/assets/debate_grand/loader.gif'),
    'debate_grand/User.svg': require('@/assets/debate_grand/User.svg'),
    // 辯論卡片狀態圖示
    'debate-card/ongoing/ongoing.svg': require('@/assets/debate-card/ongoing/ongoing.svg'),
    'debate-card/end/end.svg': require('@/assets/debate-card/end/end.svg'),
    // 辯論 VS 圖示
    'debate/VS.svg': require('@/assets/debate/VS.svg'),
    // 辯論討論區按鈕
    'debate/Like_Button.svg': require('@/assets/debate/Like_Button.svg'),
    'debate/reply_Button.svg': require('@/assets/debate/reply_Button.svg'),
    // 留言關閉按鈕
    'comment/close_button.png': require('@/assets/comment/close_button.png'),
    // 留言預設使用者頭像
    'comment/User.svg': require('@/assets/comment/User.svg'),
  };
  
  if (assetMap[name]) {
    return assetMap[name];
  }
  
  // 若找不到，嘗試直接 require（可能失敗，但不會直接報錯）
  try {
    // 支援子目錄路徑
    if (name.includes('/')) {
      // 檢查是否為 debate_grand 目錄
      if (name.startsWith('debate_grand/')) {
        return require(`@/assets/${name}`);
      }
      // 檢查是否為 avatars 目錄（使用者頭像）
      if (name.startsWith('avatars/')) {
        return require(`@/assets/${name}`);
      }
      // 檢查是否為 user-picture 目錄（使用者頭像）
      if (name.startsWith('user-picture/')) {
        return require(`@/assets/${name}`);
      }
      // 檢查是否為 join 目錄
      if (name.startsWith('join/')) {
        return require(`@/assets/${name}`);
      }
      // 檢查是否為 debate 目錄
      if (name.startsWith('debate/')) {
        return require(`@/assets/${name}`);
      }
      // 檢查是否為 comment 目錄
      if (name.startsWith('comment/')) {
        return require(`@/assets/${name}`);
      }
      // 其他子目錄都位於 new_design 下
      return require(`@/assets/new_design/${name}`);
    } else {
      return require(`@/assets/new_design/${name}`);
    }
  } catch (error) {
    // 靜默處理錯誤，不輸出警告
    return '';
  }
};
